import React, { Component } from 'react';

// import TubeStand from './img/TubeStand-shorter.svg';
// import TubeStand from './img/TubeStand longer.svg';
import TubeStand from './img/TubeStand-new.svg';

class Graphics extends Component {

  render () {
    return (
      <div>
        <img width="100px" src={TubeStand} aria-label={'Empty Tube Stand'}  alt='Empty Tube Stand'/>
      </div>
    );
  }

}

export default Graphics;
